/* eslint-disable import/no-cycle */
/* eslint-disable max-lines */
import axios from 'axios';
import { businessMapping } from './businessMapping';
import { dgiContMapping } from './dgiContMapping';
import { dgiMapping } from './dgiMapping';
import {
  buildConsentInfo,
  createDocumentProofsArray,
  createFormData,
  createSourceInformation,
  formatSSNToNumbers,
  getQuestionAndAnswers,
  returnOccupationInEN,
} from './formServiceUtils';
import { productMapping } from './productMapping';
import { productTypeMapping } from './productTypeMapping';
import {
  commonFunction,
  headersData,
  isABCProduct,
  isBundle,
  isCDIraproduct,
  isCDproduct,
  isIRAEducativaProduct,
  isIRAProduct,
  isPlaidProduct,
  isSimilarIRAProducts,
  productsNotEligibleForUsAddress,
  getVouchedEnvForPayload,
} from '../components/commonCode';
import {
  commonUtility,
  formattedDepositAmntForRegular,
  formattedDepositAmount,
  getProductForDebitCard,
  getProductForDepositeCard,
} from '../components/LeadGeneration/UtilityFunctions';
import {
  CONTENT_TYPE_APP_JSON_CHAR,
  DEBIT_CARD_REQUIRED_TEXT,
  DIRECT_DEPOSITE_RADIO_TEXT,
  DIRECT_DEPOSITE_RADIO_TEXT_NO,
  ELITE_ACCOUNT_EN,
  ELITE_ACCOUNT_ES,
  EN,
  ES,
  LIBRE_AHORRA_BUNDLE,
  PROGRESA_CONTIGO,
  SALES,
} from '../constants';
import { wcApiUrl } from '../WebComponents/commonComponents/customUtils';

export const getProductQuestionTranslation = async ({
  accessToken,
  language,
  initiateUiResponse,
  env,
  isWCFlow,
}) => {
  let productQuestionTranslation = {};
  const lang = language?.toLowerCase();
  try {
    productQuestionTranslation = await axios.get(
      commonTernary(
        isWCFlow,
        ` ${
          wcApiUrl(env).REACT_APP_PRODUCT_QUESTIONS_TRANSLATION_URL
        }/${lang}_application_rules.json`,
        `${initiateUiResponse.REACT_APP_PRODUCT_QUESTIONS_TRANSLATION_URL}/${lang}_application_rules.json`
      ),

      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return productQuestionTranslation;
  }
  return productQuestionTranslation;
};

export const getAddressLookupData = async (
  country,
  word,
  accessToken,
  setCallLookupApi,
  setCallLookupApiHome,
  setCallLookupApiEmp,
  setCallLookupApiHomeSelfEmp,
  initiateUiResponse,
  { env, isWCFlow } = {}
) => {
  let addressLookupResponse = {};
  try {
    setCallLookupApi(false);
    setCallLookupApiHome(false);
    setCallLookupApiEmp(false);
    setCallLookupApiHomeSelfEmp(false);
    addressLookupResponse = await axios.get(
      commonTernary(
        isWCFlow,
        `${wcApiUrl(env).REACT_APP_ADDRESS_LOOKUP_URL}?ff=${word}&country=${country}&maxrecords=7`,
        `${initiateUiResponse.REACT_APP_ADDRESS_LOOKUP_URL}?ff=${word}&country=${country}&maxrecords=7`
      ),
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return addressLookupResponse;
  }
  return addressLookupResponse;
};

export const getQRDetailsLookupData = async (data, accessToken, initiateUiResponse) => {
  const payload =
    data.flowTypeQRcode !== 'QRCodeInternalGeneration'
      ? {
          productType: data?.productType?.includes('Account')
            ? data.productType
            : `${data.productType} Account`,
          productName: data.productName,
          emailId: data.email,
          salesAdvisor: data.salesAdvisor,
          language: data.language === 'English' ? EN : ES,
          organization: data.organization,
        }
      : {
          salesAdvisor: data.salesAdvisor,
          salesAdvisorId: data.salesAdvisorId,
          branch: data.branch,
          primaryOfficerNumber: data.primaryOfficerNumber,
          productName: data.productName,
          emailId: data.emailId,
          costCenter: data.costCenter,
          language: data.language,
          organization: data.organization,
          productType: data.productType,
        };

  let qrDetailsLookupResponse = null;
  try {
    qrDetailsLookupResponse = await axios.post(
      initiateUiResponse.REACT_APP_QR_DETAILS_LOOKUP_URL,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (e) {
    return e.qrDetailsLookupResponse;
  }
  return qrDetailsLookupResponse;
};
export const getProductQuestions = async (
  data,
  ruleType,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow } = {}
) => {
  const formData = createFormData([ruleType], data);

  let response = null;
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_AGE_RULE_URL,
        initiateUiResponse.REACT_APP_AGE_RULE_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};
export const getProductQuestionsForFunding = async (
  data,
  ruleType,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const formData = createFormData([ruleType], data);

  let response = null;
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_AGE_RULE_URL,
        initiateUiResponse.REACT_APP_AGE_RULE_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (e) {
    return e?.response;
  }
  return response;
};
export const saveCommercialConsent = async (appId, token, initiateUiResponse, env, isWCFlow) => {
  let result = null;
  const body = {
    Event: 'CaptureBankerInfo',
    Application: {
      ApplicationID: appId,
    },
  };
  try {
    result = await axios.post(initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        appid: SALES,
        'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
      },
    });
  } catch (error) {
    return null;
  }
  return result;
};
const commonTernary = (condition, result1, result2) => {
  if (condition) {
    return result1;
  }
  return result2;
};
export const saveConsent = async (
  data,
  accessToken,
  customerType,
  flowTypeETB,
  customerAppId,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const consentContent = buildConsentInfo(data);
  const formData = {
    Event:
      data.flowType === 'invitation-form'
        ? 'CaptureBusinessConsents'
        : commonTernary(
            businessMapping(data.productName),
            'CaptureBusinessConsents',
            'CaptureConsents'
          ),
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : customerAppId,
      ...(data.flowType === 'invitation-form' && {
        ApplicantID: data.flowType === 'invitation-form' ? data.applicantId : null,
      }),

      TemplateVersion: '2021-08-05',
      ...(data.flowType === 'invitation-form' && {
        Products: [
          {
            ProductType: 'CommercialInvitation',
            ProductName: 'SecondaryApplicant',
            Category: 'Primary',
          },

          ...(data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
            ? [
                {
                  ProductType:
                    data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
                      ? 'Savings Account'
                      : 'CommercialInvitation',
                  ProductName: 'SecondaryApplicant',
                  Category: 'Secondary',
                },
              ]
            : []),
        ],
      }),

      Source: createSourceInformation(data),
      Applicants: [
        {
          ...(data.flowType === 'invitation-form' && {
            ApplicantID: data.flowType === 'invitation-form' ? data.applicantId : null,
          }),

          ApplicantCategory: businessMapping(data.productName) ? 'DigitalApplicant' : 'Primary',
          ApplicantID:
            data.flowType === 'invitation-form'
              ? data.applicantId
              : commonTernary(businessMapping(data.productName), data.applicantId, ''),

          Consents: consentContent,
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: headersData(
          customerType,
          flowTypeETB,
          customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (error) {
    return null;
  }
  return result;
};

let setProduct;
const nameProduct = (data) => {
  if (dgiMapping(data.productName)) {
    setProduct = dgiMapping(data.productName);
  } else if (dgiContMapping(data.productName)) {
    setProduct = dgiContMapping(data.productName);
  } else {
    setProduct = productMapping(data.productName);
  }
  return setProduct;
};

export const saveContactInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  env,
  isWCFlow
) => {
  const formData = {
    Event: 'CaptureContactInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: nameProduct(data),
          Category: 'Primary',
          ...(data.branch && data.costCenter && data.salesAdvisor && data.primaryOfficer
            ? {
                QrCode: {
                  Branch: data.branch,
                  CostCenter: data.costCenter,
                },
                SalesAdvisor: data.salesAdvisor,
                AccountInfo: {
                  PrimaryOfficer: data.primaryOfficer,
                },
              }
            : {}),
        },

        ...(data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
          ? [
              {
                ProductType:
                  data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
        ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType: 'Savings Account',
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
      ].filter(Boolean),
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          CustName: {
            FrstName: data.firstName,
            LstName: data.lastName,
          },
          Contacts: [
            {
              ContactType: 'email',
              ContactValue: data.email,
              Validation: {
                ValidatedBy: data.emailVerificationResponse
                  ? data.emailVerificationResponse?.validatedBy
                  : null,
                Status: data.emailVerificationResponse
                  ? data.emailVerificationResponse?.status
                  : null,
                ResultCodes: data.emailVerificationResponse
                  ? data.emailVerificationResponse.resultCode
                  : null,
                Message: data.emailVerificationResponse
                  ? data.emailVerificationResponse.message
                  : null,
                Timestamp: data.emailVerificationResponse
                  ? data.emailVerificationResponse.timestamp
                  : null,
              },
            },
            {
              ContactType: 'mobile',
              ContactValue:
                data.location !== 'VI' ? `(${data.areaCode}) ${data.phone}` : data.phone,
              PrefferedContactTime: data.preferredContactTime ? data.preferredContactTime : null,
              Validation: {
                ValidatedBy: data.phoneValidationResponse
                  ? data.phoneValidationResponse?.validatedBy
                  : null,
                Status: data.phoneValidationResponse ? data.phoneValidationResponse.status : null,
                ResultCodes: data.phoneValidationResponse
                  ? data.phoneValidationResponse.resultCodes
                  : null,
                Message: data.phoneValidationResponse ? data.phoneValidationResponse.message : null,
                Timestamp: data.phoneValidationResponse
                  ? data.phoneValidationResponse.timestamp
                  : null,
              },
            },
          ],
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
let altPhoneVal;
const altPhone = (data) => {
  if (productMapping(data?.productName) === 'Progresa Contigo') {
    if (data?.phone) {
      altPhoneVal = `(${data.areaCode}) ${data.phone}`;
    }
  } else if (data?.altPhone) {
    if (data.location !== 'VI') {
      altPhoneVal = `(${data.altAreaCode}) ${data.altPhone}`;
    } else {
      altPhoneVal = data.altPhone;
    }
  } else {
    altPhoneVal = null;
  }
  return altPhoneVal;
};

export const savePersonalInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  isVouchedSandbox,
  env,
  isWCFlow
) => {
  const vouchedData =
    data.vouchedIdData && Object.keys(data.vouchedIdData).length > 0 ? data.vouchedIdData : null;

  const formData = {
    Event: 'CapturePrimaryIdInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: nameProduct(data),
          Category: 'Primary',
          ...(data.productName === PROGRESA_CONTIGO
            ? {
                SalesAdvisor: commonUtility(data.salesAdvisor),
              }
            : {}),
        },
        ...(data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
          ? [
              {
                ProductType:
                  data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
        ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType: 'Savings Account',
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
      ],

      Applicants:
        productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ApplicantCategory: 'Primary',
                CustTaxId: formatSSNToNumbers(data.ssn),
                Gender: data.gender,
                Identifications: [
                  {
                    IdenDOB: data.dob,
                  },
                ],
              },
            ]
          : [
              {
                ApplicantCategory: 'Primary',
                CustTaxId: formatSSNToNumbers(data.ssn),
                DateOfBirth: data.dob,
                Gender: data.gender,
                ...(dgiMapping(data.productName) ? { MaritalStatus: data.maritalStatus } : {}),
                CustName: {
                  FrstName: data.firstName,
                  MdleName: commonUtility(data.middleName),
                  LstName: data.lastName,
                  SecondLstName: commonUtility(data.secondLastName),
                },
                Contacts: [
                  {
                    ContactType: 'email',
                    ContactValue: data.email,
                    Validation: {
                      ValidatedBy: commonTernary(
                        data.emailVerificationResponse,
                        data.emailVerificationResponse?.validatedBy,
                        null
                      ),
                      Status: commonTernary(
                        data.emailVerificationResponse,
                        data.emailVerificationResponse?.status,
                        null
                      ),
                      ResultCodes: commonTernary(
                        data.emailVerificationResponse,
                        data.emailVerificationResponse?.resultCode,
                        null
                      ),
                      Message: commonTernary(
                        data.emailVerificationResponse,
                        data.emailVerificationResponse?.message,
                        null
                      ),
                      Timestamp: commonTernary(
                        data.emailVerificationResponse,
                        data.emailVerificationResponse?.timestamp,
                        null
                      ),
                    },
                  },
                  {
                    ContactType: commonTernary(
                      productMapping(data.productName) === 'Progresa Contigo',
                      'mobile',
                      'alternateMobile'
                    ),
                    ContactValue: altPhone(data),
                    Validation: {
                      ValidatedBy: commonTernary(
                        data.altPhoneValidationResponse,
                        data.altPhoneValidationResponse?.validatedBy,
                        null
                      ),
                      Status: commonTernary(
                        data.altPhoneValidationResponse,
                        data.altPhoneValidationResponse?.status,
                        null
                      ),
                      ResultCodes: commonTernary(
                        data.altPhoneValidationResponse,
                        data.altPhoneValidationResponse?.resultCodes,
                        null
                      ),
                      Message: commonTernary(
                        data.altPhoneValidationResponse,
                        data.altPhoneValidationResponse?.message,
                        null
                      ),
                      Timestamp: commonTernary(
                        data.altPhoneValidationResponse,
                        data.altPhoneValidationResponse?.timestamp,
                        null
                      ),
                    },
                  },
                ],
                Identifications: [
                  {
                    IdenDOB: data.dob,
                    IdenType: vouchedData && commonUtility(vouchedData.type),
                    IdNumber: vouchedData && commonUtility(vouchedData.id),
                    StartDate: vouchedData && commonUtility(vouchedData.issueDate),
                    ExpiryDate: vouchedData && commonUtility(vouchedData.expireDate),
                    IssuingCountry: vouchedData && commonUtility(vouchedData.country),
                    IdenGender: vouchedData?.gender && commonUtility(vouchedData.gender.gender),
                  },
                ],
                EmploymentInformation: { Employer: commonUtility(data.employer) },
                AdditionalInfo: {
                  Vouched: {
                    JobId: commonUtility(data.vouchedJobId),
                    Token: commonUtility(data.vouchedToken),
                    VouchedEnv: getVouchedEnvForPayload({ initiateUiResponse, isVouchedSandbox }),
                    Address: {
                      Vouched_Address_Line_1: data.Vouched_Address_Line_1 ?? '',
                      Vouched_Address_Line_2: data.Vouched_Address_Line_2 ?? '',
                      Vouched_City: data.Vouched_City ?? '',
                      Vouched_State: data.Vouched_State ?? '',
                      Vouched_Country: data.Vouched_Country ?? '',
                      Vouched_Zip_Code: data.Vouched_Zip_Code ?? '',
                    },
                    CrossCheck: data.crossCheckResponse,
                    DlvStatusResult: commonTernary(data.dlvStatus, data.dlvStatus, ''),
                  },
                },
              },
            ],
      Processing: { CaseReference: [] },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

let status;
let valid;
const validatedBy = (data) => {
  if (data.sameMailingAddress) {
    if (data.vouchedAddrEdited || data.unverifiedIdAddressVouched) {
      valid = null;
    } else {
      valid = 'vouched';
    }
  } else {
    valid = null;
  }
  return valid;
};
const mailingStatus = (data) => {
  if (data.sameMailingAddress) {
    if (data.vouchedAddrEdited || data.unverifiedIdAddressVouched) {
      status = null;
    } else {
      status = data.vouchedStatus;
    }
  } else {
    status = null;
  }
  return status;
};
const mailingTimeStamp = (data) => {
  if (data.sameMailingAddress) {
    if (data.vouchedAddrEdited || data.unverifiedIdAddressVouched) {
      status = null;
    } else {
      status = data.vouchedTimestamp;
    }
  } else {
    status = null;
  }
  return status;
};

export const saveVouchedInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  isVouchedSandbox,
  env,
  isWCFlow
) => {
  const vouchedData =
    data.vouchedIdData && Object.keys(data.vouchedIdData).length > 0 ? data.vouchedIdData : null;

  const formData = {
    Event: 'CaptureVouchedInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: nameProduct(data),
          Category: 'Primary',
        },
        ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType:
                  productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
      ].filter(Boolean),
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          CustName: {
            FrstName: commonUtility(vouchedData?.firstName) || data.firstName,
            LstName: commonUtility(vouchedData?.lastName) || data.lastName,
          },
          Identifications: [
            {
              IdenDOB: data.dob,
              IdenType: vouchedData && commonUtility(vouchedData.type),
              IdNumber: vouchedData && commonUtility(vouchedData.id),
              StartDate: vouchedData && commonUtility(vouchedData.issueDate),
              ExpiryDate: vouchedData && commonUtility(vouchedData.expireDate),
              IssuingCountry: vouchedData && commonUtility(vouchedData.country),
              IdenGender: vouchedData?.gender && commonUtility(vouchedData.gender.gender),
            },
          ],
          AdditionalInfo: {
            Vouched: {
              JobId: commonUtility(data.vouchedJobId),
              Token: commonUtility(data.vouchedToken),
              VouchedEnv: getVouchedEnvForPayload({ initiateUiResponse, isVouchedSandbox }),
              Address: {
                Vouched_Address_Line_1: data.Vouched_Address_Line_1 ?? '',
                Vouched_Address_Line_2: data.Vouched_Address_Line_2 ?? '',
                Vouched_City: data.Vouched_City ?? '',
                Vouched_State: data.Vouched_State ?? '',
                Vouched_Country: data.Vouched_Country ?? '',
                Vouched_Zip_Code: data.Vouched_Zip_Code ?? '',
              },
              CrossCheck: data.crossCheckResponse,
              DlvStatusResult: commonTernary(data.dlvStatus, data.dlvStatus, ''),
            },
          },
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveAddressInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  env,
  isWCFlow
) => {
  const formData = {
    Event: 'CaptureAddressInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Applicants: [
        {
          Addresses: [
            {
              AddrType: 'home',
              LineOne: data.address1,
              LineTwo: commonUtility(data.address2),
              AddrCity: data.city,
              ...(productsNotEligibleForUsAddress(data.productName) && data.state === 'N/A'
                ? {}
                : { AddrState: data.state }),
              AddrCountry: data.country,
              ZipCode: data.zipCode,
              ...(data.utilityBill && {
                BillType: data.utilityBill,
              }),

              Validation: {
                ValidatedBy:
                  data.vouchedAddrEdited || data.unverifiedIdAddressVouched ? null : 'Vouched',
                Status:
                  data.vouchedAddrEdited || data.unverifiedIdAddressVouched
                    ? null
                    : data.vouchedStatus,
                ResultCodes: null,
                Message: null,
                Timestamp:
                  data.vouchedAddrEdited || data.unverifiedIdAddressVouched
                    ? null
                    : data.vouchedTimestamp,
              },
              OCRVerifiedFlag: data.ocrAddressVerified ? 'true' : 'false',
              OCRAddressEditFlag: data.ocrAddressEdit ? 'true' : 'false',
              OcrExceptions: data.ocrErrors,
              // ...(data.newAddressEdit ||
              // data.ocrAddressVerified ||
              // data.vouchedAddressVerified === false
              ...(data.utilityBill
                ? // data.retainUtilityBill === true
                  {
                    Documents: createDocumentProofsArray(
                      data.homeAddressUploadDocumentId,
                      'Home Address Proof'
                    ),
                  }
                : {}),
            },
            {
              AddrType: 'mailing',
              LineOne: data.permanentAddress1,
              LineTwo: commonUtility(data.permanentAddress2),
              AddrCity: data.permanentCity,
              AddrState: data.permanentState,
              AddrCountry: data.permanentCountry,
              ZipCode: data.permanentZipCode,
              Validation: {
                ValidatedBy: validatedBy(data),
                Status: mailingStatus(data),
                ResultCodes: null,
                Message: null,
                Timestamp: mailingTimeStamp(data),
              },
            },
          ],
          AdditionalInfo: {
            IsMailHomeAddrSame: data.sameMailingAddress,
            IsIdAddressEdited:
              data.vouchedJobId && data.vouchedAddressVerified
                ? data.vouchedAddrEdited && data.vouchedJobId && data.vouchedAddressVerified
                : data?.adrrFlag,
            UserOptionCurrentAddressFlag: data.vouchedCurrentAddressFlag ? 'true' : 'false',
            UserOptionNewAddressFlag: data.vouchedNewAddressFlag ? 'true' : 'false',
          },
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveComplianceInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  env,
  isWCFlow
) => {
  const questions = data.complianceData?.questions ? data.complianceData.questions : {};
  const formAnswer = {};
  const { itemsAnswer } = data;
  const { act22DocID } = data;
  const questionAndAnswers = getQuestionAndAnswers(questions, itemsAnswer, formAnswer, act22DocID);
  const formData = {
    Event: 'CaptureComplianceInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          ComplianceQuestions: questionAndAnswers,
          EmploymentInformation: {
            EmploymentStatus: data.employmentInformation?.employmentStatus
              ? data.employmentInformation.employmentStatus
              : null,
            Employer: data.employmentInformation?.employer
              ? data.employmentInformation.employer
              : null,
            Occupation: data.employmentInformation?.occupation
              ? returnOccupationInEN(data.employmentInformation.occupation)
              : null,
            AnnualIncome: data.employmentInformation?.annualIncome
              ? data.employmentInformation.annualIncome
              : null,
            Reason: data.employmentInformation?.reason ? data.employmentInformation.reason : null,
            SchoolName: data.employmentInformation?.schoolName
              ? data.employmentInformation.schoolName
              : null,
            SourceOfCurrentIncome: data.employmentInformation?.sourceOfCurrentIncome
              ? data.employmentInformation.sourceOfCurrentIncome
              : null,
            PreviousEmployer: data.employmentInformation?.previousEmployer
              ? data.employmentInformation.previousEmployer
              : null,
          },
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveProductInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const questionsSavings = data?.productData?.questions ? data?.productData?.questions : {};
  const questions = data?.productDataSavings?.questions ? data?.productDataSavings?.questions : {};
  const { formAnswer, itemsAnswer, formAnswerSavings, itemsAnswerSavings } = data;
  const act22DocID = null;
  const questionAndAnswers = getQuestionAndAnswers(
    questionsSavings,
    itemsAnswer,
    formAnswer,
    act22DocID,
    data
  );
  const questionAndAnswersSavings = getQuestionAndAnswers(
    questions,
    itemsAnswerSavings,
    formAnswerSavings,
    act22DocID,
    data
  );

  const questionAndAnswersFiltered = questionAndAnswers.filter(
    (item) => item.Name !== 'WitholdInterest'
  );
  const products = isBundle(data?.productName)
    ? [
        {
          ProductType: 'Checking Account',
          ProductName: productMapping(data.productName),
          Questions: data.productAccountType
            ? questionAndAnswersFiltered
            : questionAndAnswersSavings,
          Category: 'Primary',
          ...(data.branch && data.costCenter && data.salesAdvisor && data.primaryOfficer
            ? {
                QrCode: {
                  Branch: data.branch,
                  CostCenter: data.costCenter,
                },
                SalesAdvisor: data.salesAdvisor,
                AccountInfo: {
                  PrimaryOfficer: data.primaryOfficer,
                },
              }
            : {}),
        },
        {
          ProductType: 'Savings Account',
          ProductName: productMapping(data.productName),
          Questions: questionAndAnswers,
          Category: 'Secondary',
        },
      ]
    : isSimilarIRAProducts(data?.productName)
    ? [
        {
          ProductType: 'IRA',
          ProductName: productMapping(data.productName),
          InterestInfo: {
            AccruedInterestMethod: 'Interest deposited into this IRA',
          },
          DepositInfo: {
            ContributionYear: data.contributionYear,
            ...(data?.depositAmount && { DepositAmount: data.depositAmount }),

            ...(data?.taxExtensionDocID && {
              Documents: [
                {
                  DocType: data?.docType,
                  DocId: data.taxExtensionDocID,
                },
              ],
            }),
          },
          Questions: [],
          Category: 'Primary',
        },
      ]
    : [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: productMapping(data.productName) || businessMapping(data.productName),
          ...(getProductForDebitCard(data.productName)
            ? { IsDebitCardRequested: data.debitCardFlag === true ? 'true' : 'false' }
            : {}),
          ...(getProductForDepositeCard(data.productName)
            ? {
                IsDirectDeposited:
                  data.depositeCardFlag === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
              }
            : {}),
          ...(isCDproduct(data.productName)
            ? {
                InterestInfo: {
                  AccruedInterestMethod: commonUtility(data.accruedInterestMethod),
                  AccountType: commonUtility(data.accountType),
                  AccountNumber: commonUtility(data.accountNumber),
                  RoutingNumber: commonUtility(data.routingNumber),
                  ExistingAccountId: commonUtility(data.existingId),
                  BankName: bankName(data),
                },
              }
            : {}),
          Questions: questionAndAnswers,
          ...(data.productName === 'Progresa Contigo'
            ? {
                SalesAdvisor: data.salesAdvisor || null,
              }
            : {}),
          ...(data.branch && data.costCenter && data.salesAdvisor && data.primaryOfficer
            ? {
                QrCode: {
                  Branch: data.branch,
                  CostCenter: data.costCenter,
                },
                SalesAdvisor: data.salesAdvisor,
                AccountInfo: {
                  PrimaryOfficer: data.primaryOfficer,
                },
              }
            : {}),
          Category: 'Primary',
        },

        ...(data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
          ? [
              {
                ProductType:
                  data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: productMapping(data.productName) || businessMapping(data.productName),
                ...(getProductForDebitCard(data.productName)
                  ? { IsDebitCardRequested: data.debitCardFlag === true ? 'true' : 'false' }
                  : {}),
                ...(getProductForDepositeCard(data.productName)
                  ? {
                      IsDirectDeposited:
                        data.depositeCardFlag === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
                    }
                  : {}),
                Questions: questionAndAnswers,
                Category: 'Secondary',
              },
            ]
          : []),
      ];

  const beneficiaries = data
    ? [
        {
          ...(data?.beneficiaryEtbView === true
            ? {
                BeneficiaryCustId: data?.beneficiaryList?.beneficiaryCustId,
                BeneficiaryFullName: data?.beneficiaryList?.beneficiaryName,
                BeneficiaryTaxId: data?.beneficiaryList?.beneficiaryTaxID,
                RelationType: data?.beneficiaryList?.relationType,
                SpecificRelation: data?.beneficiaryList?.specificRelation,
                DobUploadFlag: data?.beneficiaryList?.dobUploadFlag,
                Documents: [
                  ...(data.birthDocId
                    ? [
                        {
                          DocType: data.birthDocType,
                          DocId: data.birthDocId,
                        },
                      ]
                    : []),
                ],
              }
            : {
                BeneficiaryTaxId: data?.beneficiaryTaxId,
                Gender: data.gender,
                BeneficiaryDOB: data.beneficiaryDOB,
                BeneficiaryName: {
                  FrstName: data.frstName,
                  MdleName: data.mdleName,
                  LstName: data.lstName,
                  SecondLstName: data.secondLstName,
                },
                AddressSameAsApplicant: data.addressSameAsApplicant,
                RelationType: data.relationType,
                SpecificRelation: data.specificRelation ?? '',
                LegalGuardian: data.legalGuardian,

                Documents: [
                  {
                    DocType: data.birthDocType,
                    DocId: data.birthDocId,
                  },
                  ...(data.authorityDocId
                    ? [
                        {
                          DocType: data.authorityDocType,
                          DocId: data.authorityDocId,
                        },
                      ]
                    : []),
                ],
                Addresses: [
                  {
                    AddrType: 'home',
                    LineOne: data.lineOne,
                    LineTwo: data.lineTwo,
                    AddrCity: data.addrCity,
                    AddrState: data.addrState,
                    AddrCountry: data.addrCountry,
                    ZipCode: data.zipCode,
                  },
                ],
                ...(data.legalGuardian === false && {
                  CAE: {
                    EmailType: data.emailType,
                    EmailId: data.emailId,
                    Validation: {
                      ValidatedBy: data.emailVerificationResponse
                        ? data.emailVerificationResponse?.validatedBy
                        : null,
                      Status: data.emailVerificationResponse
                        ? data.emailVerificationResponse?.status
                        : null,
                      ResultCodes: data.emailVerificationResponse
                        ? data.emailVerificationResponse.resultCodes
                        : null,
                      Message: data.emailVerificationResponse
                        ? data.emailVerificationResponse.message
                        : null,
                      Timestamp: data.emailVerificationResponse
                        ? data.emailVerificationResponse.timestamp
                        : null,
                    },
                  },
                }),
              }),
        },
      ]
    : [];

  const formData = {
    Event: 'CaptureProductInfo',
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : data.customerAppId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE && {
        BundleProductToggle: data.productAccountType ? 'true' : 'false',
      }),
      Products: products,
      ...(isIRAEducativaProduct(data?.productName) && {
        Beneficiaries: beneficiaries,
      }),
      Processing: { CaseReference: [] },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveBeneficiaryInformation = async (
  data,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const products = [
    {
      ProductType: 'Savings Account',
      ProductName: productMapping(data.productName),
      Questions: [],
      Category: 'Primary',
    },
  ];
  const documents = [
    ...(data.birthDocId
      ? [
          {
            DocType: data.birthDocType,
            DocId: data.birthDocId,
          },
        ]
      : []),
    ...(data.authorityDocId
      ? [
          {
            DocType: data.authorityDocType,
            DocId: data.authorityDocId,
          },
        ]
      : []),
  ];
  const beneficiaries = [
    {
      ...(data?.beneficiaryEtbView === true
        ? {
            BeneficiaryCustId: data?.beneficiaryList?.beneficiaryCustId,
            BeneficiaryFullName: data?.beneficiaryList?.beneficiaryName,
            BeneficiaryTaxId: data?.beneficiaryList?.beneficiaryTaxID,
            BeneficiaryDOB: data?.beneficiaryList?.beneficiaryDOB,
            AddressSameAsApplicant: data.addressSameAsApplicant,
            RelationType: data.relationType,
            SpecificRelation: data.specificRelation ?? '',
            DobUploadFlag: data?.beneficiaryList?.dobUploadFlag,
            Documents: documents,
          }
        : {
            BeneficiaryTaxId: data?.beneficiaryTaxId,
            Gender: data.gender,
            BeneficiaryDOB: data.beneficiaryDOB,
            BeneficiaryName: {
              FrstName: data.frstName,
              MdleName: data.mdleName,
              LstName: data.lstName,
              SecondLstName: data.secondLstName,
            },
            AddressSameAsApplicant: data.addressSameAsApplicant,
            RelationType: data.relationType,
            SpecificRelation: data.specificRelation ?? '',
            Documents: documents,
            Addresses: [
              ...(!data.isETB
                ? [
                    {
                      AddrType: 'home',
                      LineOne: data.lineOne,
                      LineTwo: data.lineTwo,
                      AddrCity: data.addrCity,
                      AddrState: data.addrState,
                      AddrCountry: data.addrCountry,
                      ZipCode: data.zipCode,
                    },
                    {
                      AddrType: 'mailing',
                      LineOne: data.lineOneMailing,
                      LineTwo: data.lineTwoMailing,
                      AddrCity: data.addrCityMailing,
                      AddrState: data.addrStateMailing,
                      AddrCountry: data.addrCountryMailing,
                      ZipCode: data.zipCodeMailing,
                    },
                  ]
                : []),
            ],
            BeneficiaryInSchool: data.beneficiaryInSchool,
            ...(data.beneficiaryInSchool && {
              EmploymentInformation: {
                SchoolName: data.schoolName,
              },
            }),
          }),
    },
  ];

  const formData = {
    Event: 'CaptureBeneficiaryInfo',
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : data.customerAppId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: products,
      Beneficiaries: beneficiaries,
      Processing: { CaseReference: [] },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const fundingAccount = (data) => {
  let account;
  if (data.accountTransferOrCheck && data.orientalAccount) {
    account = 'OrientalAccount';
  } else if (data.accountTransferOrCheck && data.anotherBankAccount) {
    account = 'AnotherBankAccount';
  } else {
    account = null;
  }
  return account;
};
export const fundingAccountProgressa = (ctx) => {
  const { customerType, accNoListForOrientalAccount, productName, fundData } = ctx;
  let acc = null;
  if (
    customerType === 'ETB' &&
    accNoListForOrientalAccount?.length > 0 &&
    isPlaidProduct(productName) &&
    fundData?.orientalAccount
  ) {
    acc = 'OrientalAccount';
  } else {
    acc = 'AnotherBankAccount';
  }
  return acc;
};
export const bankName = (data) => {
  let bankType;
  if (data.bank) {
    if (data.bank === 'Other') {
      bankType = data.otherBank;
    } else {
      bankType = data.bank;
    }
  } else {
    bankType = null;
  }
  return bankType;
};
export const getVerificationMode = (ctx) => {
  const {
    statementDocumentId,
    statementUploadStatus,
    customerType,
    fundData,
    accNoListForOrientalAccount,
    plaidDetails,
  } = ctx;
  let verfifcationMode = '';
  let accountVerified = '';
  let accNum = '';
  if (
    customerType === 'ETB' &&
    fundData.orientalAccount &&
    accNoListForOrientalAccount?.length > 0
  ) {
    verfifcationMode = 'internal_verified';
    accountVerified = 'Yes';
    accNum = '';
  }
  if (statementDocumentId !== null && statementUploadStatus !== null) {
    verfifcationMode = 'manual';
    accountVerified = 'No';
    accNum = fundData.accountNumber;
  }
  if (plaidDetails?.status === 'Success') {
    verfifcationMode = plaidDetails?.verificationType;
    accountVerified = plaidDetails?.verificationType === 'external_microdeposit' ? 'No' : 'Yes';
    accNum = '';
  }
  return { verfifcationMode, accountVerified, accNum };
};

const getExistingAccId = (context) => {
  let accId = '';
  const { fundData, plaidAccNoLinked, plaidSuccessDetails, orientalAccountCardValue } = context;
  if (plaidAccNoLinked.length > 1) {
    accId = plaidSuccessDetails?.accId;
  } else if (fundData.orientalAccount) {
    accId = orientalAccountCardValue?.Id;
  } else {
    accId = plaidAccNoLinked[0]?.Id;
  }

  return accId;
};

const getAccountType = (data, context) => {
  const { plaidAccNoLinked, fundData } = context;
  let accType = '';
  if (plaidAccNoLinked.length < 2 && !fundData.orientalAccount && !data.statementDocumentId) {
    accType = plaidAccNoLinked[0]?.AccountType;
  } else {
    accType = data.typeOfAccount;
  }
  return accType;
};
const getTransistNumber = (data, context) => {
  const { plaidAccNoLinked, fundData } = context;
  let routingNum = '';
  if (plaidAccNoLinked.length < 2 && !fundData.orientalAccount && !data.statementDocumentId) {
    routingNum = plaidAccNoLinked[0]?.RoutingNumber;
  } else {
    routingNum = data.transitNumber === 'Other' ? data.customTransitNumber : data.transitNumber;
  }
  return routingNum;
};

export const saveFundingDataWithPlaid = async (
  data,
  context,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const { accessToken } = context;
  const fundingInfo = {
    VerificationMode: getVerificationMode(context).verfifcationMode,
    IsAccountVerified: getVerificationMode(context).accountVerified,
    ExistingAccountId: getExistingAccId(context),
    FundingType: fundingAccountProgressa(context),
    BankName: bankName(data),
    AccountNumber: getVerificationMode(context).accNum,
    AccountType: getAccountType(data, context) || '',
    TransitNumber: getTransistNumber(data, context) || '',
    DepositAmount: formattedDepositAmount(data.depositAmount),
    Documents: createDocumentProofsArray(data.statementDocumentId, 'Check/Bank Statement'),
    SourceOfFunds: commonFunction(context.fundData?.sourceofFunds?.value),
  };

  const productObject = {
    ProductType: productTypeMapping(data.productType),
    ProductName: productMapping(data.productName),
    Category: 'Primary',
    FundingInfo: { ...fundingInfo },
    ...(isIRAProduct(data.productName) || isABCProduct(data.productName)
      ? { IsFundingRequired: 'true' }
      : null),
  };

  const bundleCheckingAcc =
    productMapping(data.productName) === LIBRE_AHORRA_BUNDLE &&
    productTypeMapping(data.productType) === 'Checking Account';

  const formData = {
    Event: 'CaptureFundingInfo',
    Application: {
      ApplicationID: data.applicationId || data.customerAppId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products:
        productMapping(data.productName) === ELITE_ACCOUNT_EN ||
        productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ...productObject,
                ...(bundleCheckingAcc
                  ? { FundingInfo: undefined }
                  : { FundingInfo: { ...fundingInfo } }),
              },
              {
                ...productObject,
                ProductType: 'Savings',
                Category: 'Secondary',
              },
            ]
          : [{ ...productObject }],
      Processing: { CaseReference: [] },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (error) {
    return error?.response;
  }

  return result;
};

export const saveFundingInfo = async (data, accessToken, initiateUiResponse, { env, isWCFlow }) => {
  const BundleProducts = [
    {
      ProductType: 'checking Account',
      ProductName: productMapping(data.productName),
      Category: 'Primary',
    },
    {
      ProductType: 'Saving Account',
      ProductName: productMapping(data.productName),
      FundingInfo: {
        VerificationMode: 'manual',
        IsAccountVerified: 'No',
        FundingType: fundingAccount(data),
        BankName: bankName(data),
        AccountNumber: data.accountNumber ? data.accountNumber : null,
        AccountType: data.typeOfAccount ? data.typeOfAccount : null,
        TransitNumber:
          data.transitNumber === 'Other' ? data?.customTransitNumber : data.transitNumber,
        DepositAmount: formattedDepositAmntForRegular(data.depositAmount),
        IsAccountBelongsToYou:
          fundingAccount(data) === 'AnotherBankAccount'
            ? commonUtility(data.isAccountBelongsToYou)
            : null,
        Documents: createDocumentProofsArray(data.statementDocumentId, 'Check/Bank Statement'),
        SourceOfFunds: data.sourceofFunds,
      },
      Category: 'Secondary',
    },
  ];
  const formData = {
    Event: 'CaptureFundingInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products:
        productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? BundleProducts
          : [
              {
                ProductType: productTypeMapping(data.productType),
                ProductName: productMapping(data.productName),
                FundingInfo: {
                  FundingType: fundingAccount(data),
                  BankName: bankName(data),
                  AccountNumber: data.accountNumber ? data.accountNumber : null,
                  AccountType: data.typeOfAccount ? data.typeOfAccount : null,
                  TransitNumber:
                    data.transitNumber === 'Other' ? data?.customTransitNumber : data.transitNumber,
                  DepositAmount: formattedDepositAmntForRegular(data.depositAmount),
                  IsAccountBelongsToYou:
                    fundingAccount(data) === 'AnotherBankAccount'
                      ? commonUtility(data.isAccountBelongsToYou)
                      : null,
                  Documents: createDocumentProofsArray(
                    data.statementDocumentId,
                    'Check/Bank Statement'
                  ),
                  SourceOfFunds: commonFunction(data.sourceofFunds),
                },
                Category: 'Primary',
              },
            ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: headersData(
          data.customerType,
          data.flowTypeETB,
          data.customerAppId,
          accessToken,
          CONTENT_TYPE_APP_JSON_CHAR
        ),
      }
    );
  } catch (error) {
    return error.response;
  }

  return result;
};

export const getAccountValidation = async (
  data,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_ACCOUNT_VALIDATION,
        initiateUiResponse.REACT_APP_ACCOUNT_VALIDATION
      ),
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const getCustomerValidation = async (
  ssn,
  ctx,
  initiateUiResponse,
  { env, isWCFlow } = {}
) => {
  const payload = {
    TaxID: ssn,
    AccountCheckFlag: 'false',
    ...(ctx.flowTypeETB === 'EtbFlow' ? '' : { GenerateApplicationId: 'true' }),
  };
  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_CUSTOMER_VALIDATION,
        initiateUiResponse.REACT_APP_CUSTOMER_VALIDATION
      ),
      payload,
      {
        headers: {
          Authorization: `Bearer ${ctx.accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const getOcrAddressValidation = async (data, accessToken, initiateUiResponse) => {
  const payload = {
    documentId: data.docId,
    format: data.docFormat,
    billType: data.billType,
  };
  let result = null;
  try {
    result = await axios.post(initiateUiResponse.REACT_APP_OCR_EXTRACT_ADDRESS, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveContinueInformation = async (data, accessToken, initiateUiResponse) => {
  const formData = {
    TemplateVersion: '2023-07-28',
    ApplicationID: data.applicationId,
    FrstName: data.firstName,
    LstName: data.lastName,
    language: data.language,
    location: data.location,
    dob: data.dob,
    email: data.email,
    taxID: formatSSNToNumbers(data.ssn),
  };

  let result = null;
  try {
    result = await axios.post(initiateUiResponse.REACT_APP_SAVE_CONTINUE, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

export const buildSession = async (applicationId, accessToken, initiateUiResponse) => {
  let sessionResponse = {};
  try {
    sessionResponse = await axios.get(`${initiateUiResponse.REACT_APP_CUSTOMER_BUILD_SESSION}`, {
      // eslint-disable-next-line prettier/prettier
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Application-Id': `${applicationId}`,
      },
    });
  } catch (e) {
    return sessionResponse;
  }
  return sessionResponse;
};
export const fetchVouchedAddress = async (jobId, accessToken, initiateUiResponse) => {
  let result = null;

  try {
    result = await axios.get(
      `${initiateUiResponse.REACT_APP_GET_VOUCHED_DS_INFO}?jobId=${jobId}&source=salesUi&env=live`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const fetchVouchedSandboxAddress = async (jobId, accessToken, initiateUiResponse) => {
  let result = null;

  try {
    result = await axios.get(
      `${initiateUiResponse.REACT_APP_GET_VOUCHED_DS_INFO}?jobId=${jobId}&source=salesUi&env=sandbox`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const saveFeatureInformation = async (
  data,
  accessToken,
  excessTransferFeature,
  excessAmtError,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const formData = {
    Event: 'CaptureFeatureInfo',
    Application: {
      ApplicationID: data.applicationId || data.customerAppId,
      TemplateVersion: '2021-08-05',
      ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE && {
        BundleFeatureToggle: data.productAccountTypeFeature ? 'true' : 'false',
      }),
      Source: createSourceInformation(data),
      Products: [
        ...(productMapping(data.productName) === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType: 'Checking Account',
                ProductName: productMapping(data.productName),
                Category: 'Primary',
                IsDebitCardRequested: data.masterDebitCardDisburseFeature ? 'true' : 'false',
                IsDirectDeposited: data.debitCardDisburseFeature ? 'true' : 'false',
              },
              {
                ProductType: 'Savings Account',
                ProductName: productMapping(data.productName),
                Category: 'Secondary',
                IsFundingRequired: 'true',
                IsDebitCardRequested: data.masterDebitCardDisburseFeatureSavings ? 'true' : 'false',
                IsDirectDeposited: data.debitCardDisburseFeatureSavings ? 'true' : 'false',
              },
            ]
          : data.productName === ELITE_ACCOUNT_EN || data.productName === ELITE_ACCOUNT_ES
          ? [
              {
                ProductType: productTypeMapping(data.productType),
                ProductName: productMapping(data.productName),
                Category: 'Primary',

                IsFundingRequired: 'true',

                IsCombinedStatementsRequired: 'true',
                IsDeficitTransferRequired: 'true',

                IsExcessTransferRequired:
                  data.autoTransfer === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
                ExcessLimitAmount:
                  (excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO &&
                    excessAmtError.excessAmtVal === '') ||
                  excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT
                    ? data.excessAmount
                    : '',
                IsDebitCardRequested: data.debit === DEBIT_CARD_REQUIRED_TEXT ? 'true' : 'false',
                IsDirectDeposited: data.deposite === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
              },
              {
                ProductType: 'Savings Account',
                ProductName: productMapping(data.productName),
                Category: 'Secondary',

                IsCombinedStatementsRequired: 'true',
              },
            ]
          : [
              {
                ProductType: productTypeMapping(data.productType),
                ProductName: productMapping(data.productName),
                Category: 'Primary',

                ...(data.productName === 'Libre Account' || data.productName === 'Cuenta Libre'
                  ? {
                      IsFundingRequired:
                        data.fundingStatus === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
                    }
                  : { IsFundingRequired: 'true' }),
                IsDebitCardRequested: data.debit === DEBIT_CARD_REQUIRED_TEXT ? 'true' : 'false',
                IsDirectDeposited: data.deposite === DIRECT_DEPOSITE_RADIO_TEXT ? 'true' : 'false',
              },
            ]),
      ],
      Processing: {
        CaseReference: [],
      },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          ...(data.flowTypeETB === 'EtbFlow' && {
            'Application-Id': data.customerAppId,
          }),
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const saveInfo = async (data, token, initiateUiResponse) => {
  let result = null;
  try {
    result = await axios.post(initiateUiResponse.REACT_APP_RETURN_TO_APPLICATION_URL, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        appid: SALES,
        'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

export const CDOffers = async ({
  accessToken,
  location,
  productName,
  initiateUiResponse,
  env,
  isWCFlow,
}) => {
  let result = null;
  const region = isIRAEducativaProduct(productName)
    ? location === 'PR'
      ? 'PR_IRA_EDU'
      : 'USVI_IRA_EDU'
    : isCDIraproduct(productName)
    ? location === 'PR'
      ? 'PR_CDIRA'
      : 'USVI_CDIRA'
    : location === 'PR'
    ? 'PR'
    : 'USVI';
  try {
    result = await axios.get(
      commonTernary(
        isWCFlow,
        `${wcApiUrl(env).REACT_APP_CD_INTEREST_PLAN_DETAILS}?region=${region}`,
        `${initiateUiResponse.REACT_APP_CD_INTEREST_PLAN_DETAILS}?region=${region}`
      ),
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const CDSaveOffers = async (data, accessToken, initiateUiResponse, { env, isWCFlow }) => {
  const formData = {
    Event: 'CaptureDepositInfo',
    Application: {
      ApplicationID: data.applicationId,
      ...(data?.requestSource && isWCFlow
        ? { ApplicationFlow: 'Express' }
        : data.flowTypeETB === 'EtbFlow' && { ApplicationFlow: 'ExpressPreAuthentication' }),
      TemplateVersion: '2021-08-05',
      Source: {
        Language: data.language,
        Location: data.location,
        UtmSource: data.utmSource,
        UtmMedium: data.utmMedium,
        UtmCampaign: data.utmCampaign,
        UtmContent: data.utmContent,
        UtmTerm: data.utmTerm,
        BranchCode: data.branchCode,
        ...(data?.requestSource && { RequestSource: data?.requestSource }),
        ...(data?.devicePlatform && { DevicePlatform: data?.devicePlatform }),
        ...(!data?.savedDataFlow && { Google_CID: data.googleCID ?? '' }),
      },
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: productMapping(data.productName),
          Category: 'Primary',
          DepositInfo: {
            DepositAmount: formattedDepositAmount(data.depositAmount),
            CDTerm: data.cdTerm,
            APY: data.apy,
            InterestPlan: data.interestPlan,
            APR: data.apr,
            IRAType: data.iraType,
          },
        },
      ],
      Processing: {
        CaseReference: [],
      },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
        initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const checkLibrePlus = async (applicationId, accessToken, initiateUiResponse) => {
  let result = null;

  try {
    result = await axios.get(
      `${initiateUiResponse.REACT_APP_GET_LIBRE_PLUS_PRODUCT}${applicationId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }

  return result;
};

export const saveLibrePlusAccount = async (data, accessToken, initiateUiResponse) => {
  const formData = {
    Event: 'InitiateAddOnFlow',
    Application: {
      TemplateVersion: '2025-07-24',
      Source: {
        Language: data.language,
        Location: data.location,
        UtmSource: data.utmSource,
        UtmMedium: data.utmMedium,
        UtmCampaign: data.utmCampaign,
        UtmContent: data.utmContent,
        UtmTerm: data.utmTerm,
        BranchCode: data.branchCode,
        ...(!data?.savedDataFlow && { Google_CID: data.googleCID ?? '' }),
      },
      ApplicationID: data.secondApplicationId,
      ApplicationFlow: 'Plus',
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: productMapping(data.productNm),
          Category: 'Primary',
        },
      ],
      Applicants: [],
      Processing: {
        CaseReference: [],
      },
    },
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
          // 'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const getContributionYear = async (
  data,
  accessToken,
  product,
  appId,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  const formData = {
    TaxID: data?.ssn?.replace(/\D/g, ''),
    ProductName: product,
    ApplicationID: appId,
  };

  let result = null;
  try {
    result = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_GET_CONTRIBUTION_YEAR,
        initiateUiResponse.REACT_APP_GET_CONTRIBUTION_YEAR
      ),
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const getEmployeeDetails = async (query, accessToken, initiateUiResponse) => {
  let result = null;
  try {
    result = await axios.get(`${initiateUiResponse.REACT_APP_GET_EMPLOYEE_NUMBER}?${query}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': CONTENT_TYPE_APP_JSON_CHAR,
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
